import { render, staticRenderFns } from "./DistributeHistory.vue?vue&type=template&id=0cb4cdaa&scoped=true&"
import script from "./DistributeHistory.vue?vue&type=script&lang=js&"
export * from "./DistributeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4cdaa",
  null
  
)

export default component.exports